import React, { useState, useEffect } from 'react';
import axios from 'axios';
import base_url from '../../../base_url';
import {localStorageUserKey} from '../../../local_storage_vars';
import { smartStorage } from "../../../smart_storage";

function OnboardHandyman() {
  const [connectedAccountId, setConnectedAccountId] = useState(null);
  const [status, setStatus] = useState(null);
  const [name, setName] = useState('');
  const [userType, setUserType] = useState('');

  const createAccount = () => {
    const user = smartStorage.get(localStorageUserKey);
    const apiUrl = `${base_url}/apis/user_membership/create-account`;

    axios.post(apiUrl, {}, 
    {
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_API_KEY,
        authorization: user
      }
    })
      .then(res => {
        setConnectedAccountId(res.data.accountId); 
        smartStorage.set(localStorageUserKey, res.data.token); 

        return axios.post(`${base_url}/apis/user_membership/onboarding-link`, {
          accountId: res.data.accountId
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': process.env.REACT_APP_API_KEY,
            authorization: user
          }
        });
      })
      .then(res => {
        window.location.href = res.data.url; // redirect to Stripe onboarding
      })
      .catch(err => {
        console.error(err);
        alert('Something went wrong.');
      });
  };

  const completeOnboarding = () => {
    const user = smartStorage.get(localStorageUserKey);
    const apiUrl = `${base_url}/apis/user_membership/onboarding-link`;

    axios.post(apiUrl, {
        accountId: connectedAccountId
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_API_KEY,
          authorization: user
        }
      })
      .then(res => {
        window.location.href = res.data.url; // redirect to Stripe onboarding
      })
      .catch(err => {
        console.error(err);
        alert('Something went wrong.');
      });
  };

  const checkStatus = async() => {

    const user = await smartStorage.get(localStorageUserKey);
    const apiUrl = `${base_url}/apis/user_membership/account-status/`; //${connectedAccountId}`;

    axios.get(apiUrl, {
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_API_KEY,
        'authorization': user
      }
    })
    .then(res => {
      setStatus(res.data);
    })
    .catch(err => {
      console.error(err.response.data.error);
      console.error(err);
      alert(err.response.data.error);
    });
  };

 const GetUserDetais = async()=>{
    const user = await smartStorage.get(localStorageUserKey);

    await axios.get(`${base_url}/apis/auth/profile`,{
      headers: {
        "x-api-key": process.env.REACT_APP_API_KEY,
        "authorization": user,
        'Content-Type': 'application/json', 
      },
    })
    .then(res=>{
      if(res.status == 200){
      
        if(res.data.user.user_type == "contractor"){
          setConnectedAccountId(res.data.user.connectedAccountId);
          if(res.data.user.connectedAccountId != null && res.data.user.connectedAccountId != undefined){
            checkStatus();
          }
        }else{ }
       setName(res.data.user.username)
       setUserType(res.data.user.user_type)
      }else{
        alert(res.data.message)
      }
    })
    .catch(err=>{
      if(err.response && err.response.data){
        alert(err.response.data.message)
       }else{
        alert("Something went wrong")
       }
    })
  }
 
    useEffect(()=>{
      GetUserDetais();
    },[])

  return (
    <div style={{ padding: '1em' }}>
      <h2>Handyman Onboarding</h2> {  <p>Welcome, {name}!</p>}
      { (!connectedAccountId || connectedAccountId === null || connectedAccountId === undefined) && <div>
      <p>To start accepting jobs, you need to connect your Stripe account.</p>
      <p>Click the button below to create a Stripe account and complete the onboarding process.</p>
      <p style={{ padding: '5px', backgroundColor: 'Red', opacity: 0.8, borderRadius: '5px', border: '1px solid darkred', color: 'white' }}>
          <b>Important! Be sure to add your Date of Birth and last 4 digits of your SSN in Personal Details 
            and wait for Verification to be completed for successful onboarding.</b></p>
      <button onClick={createAccount} disabled={connectedAccountId}>
        {connectedAccountId ? 'Account Created' : 'Create Stripe Account'}
      </button>
      </div>}
 <p><strong>Account ID:</strong> {connectedAccountId}</p>
  { console.log({connectedAccountId})}
      {connectedAccountId && (
        <div>
          <p><strong>Account ID:</strong> {connectedAccountId}</p>
         
        </div>
      )}

      {status && (
        <div style={{ marginTop: '1em' }}>
          <h4>Status:</h4>
          <ul>
            <li>Charges Enabled: {status.charges_enabled ? '✅' : '❌'}</li>
            <li>Payouts Enabled: {status.payouts_enabled ? '✅' : '❌'}</li>
            <li>Details Submitted: {status.details_submitted ? '✅' : '❌'}</li>
            {status.requirements?.currently_due?.length > 0 && (
              <li>Missing: {status.requirements.currently_due.join(', ')}</li>
            )}
          </ul>
          <p><strong>Account Type:</strong> {status.account_type}</p>
          <p><strong>Account Created At:</strong> {new Date(status.created_at * 1000).toLocaleString()}</p>
          {status.loginLink && ( 
            <>
              <h4>Account Transactions</h4>
              <a href={status.loginLink}
                  target="_blank" rel="noopener noreferrer">
                  View Transactions on Stripe Dashboard and Manage your Account
              </a>
            </>
          )}
          {status.errorMessage && !status.loginLink && (
            <>
              <p><strong>Error Message:</strong> {status.errorMessage}</p>
              <button onClick={completeOnboarding} >
              Complete Onboarding
              </button>
            </>
          )}

         

        </div>
      )}

    </div>
  );
}

export default OnboardHandyman;
